
define('ldsh!modules/form_editor/templates/preview_group', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<label\n  class="control-label col-sm-3"\n  for=""\n  style="display: block;">' +
((__t = ( labelVisible ? labelText : "" )) == null ? '' : __t) +
'</label>\n<div class="col-sm-9 js-control js-items ' +
((__t = ( alignLeft? 'predef-item' : '' )) == null ? '' : __t) +
'"></div>\n';

}
return __p
};});

